import { TypeOffre } from '../../hooks';

export const getKeyTitre = (typeOffre: TypeOffre): string => {
    switch (typeOffre) {
        case TypeOffre.UN_ANS_FIXE_FERME:
        case TypeOffre.DEUX_ANS_FIXE_FERME:
        case TypeOffre.TROIS_ANS_FIXE_FERME:
        case TypeOffre.QUARANTE_MOIS_FIXE_FERME:
        case TypeOffre.TRENTENEUF_MOIS_FIXE_FERME:
        case TypeOffre.QUARANTE_DEUX_MOIS_FIXE_FERME:
        case TypeOffre.CINQUANTE_CINQ_MOIS_FIXE_FERME:
        case TypeOffre.CINQ_ANS_FIXE_FERME:
        case TypeOffre.QUATRE_ANS_FIXE_FERME:
        case TypeOffre.SEPT_ANS_FIXE_FERME:
            return 'titreFermeTauxFixe';
        case TypeOffre.CINQ_ANS_REVISABLE_FERME:
            return 'titre5AnsFermeRevisableAnnuellement';
        case TypeOffre.CINQ_ANS_VARIABLE_REDUIT:
            return 'titre5AnsFermeVariableReduit';
        case TypeOffre.CINQ_ANS_VARIABLE_PROTEGE:
            return 'titre5AnsFermeVariableProtege';
        default:
            return '';
    }
};
